var render = function render(){var _vm=this,_c=_vm._self._c;return _c('di',[_c('el-button',{attrs:{"type":"text"},on:{"click":function($event){return _vm.call(_vm.column, _vm.row)}}},[_vm._v(" "+_vm._s(_vm.rowValue)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }